export default {
  primary: {
    main: "#05a",
    light: "#1565c0",
  }
}
